import { ISplashLoaderStateService } from "./i-splash-loader-state.service";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class SplashLoaderStateService implements ISplashLoaderStateService {
    private readonly _isVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public readonly isVisible$: Observable<boolean> = this._isVisible$.asObservable();

    private readonly _isBlockingLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public readonly isBlockingLoader$: Observable<boolean> = this._isBlockingLoader$.asObservable();

    setIsVisible(isVisible: boolean): void {
        this._isVisible$.next(isVisible);
    }

    setIsBlockingLoader(isBlockingLoader: boolean): void {
        this._isBlockingLoader$.next(isBlockingLoader);
    }
}
